export default __webpack_public_path__ + "static/media/Trekzen.8830e0f2.jpeg";